const INGREDIENT_KEYWORD_SUBTYPES = {
  MISSPELLINGS: {
    id: 'MISSPELLINGS',
    term: 'Misspellings',
    childrenKeyTypes: [
      {
        id: 'LEMMATIZATIONS',
        term: 'Lemmatizations',
      },
    ],
  },
  TRANSLATIONS: {
    id: 'TRANSLATIONS',
    term: 'Translations',
    childrenKeyTypes: [
      { id: 'MISSPELLINGS', term: 'Misspellings' },
      {
        id: 'LEMMATIZATIONS',
        term: 'Lemmatizations',
      },
    ],
  },
  LEMMATIZATIONS: {
    id: 'LEMMATIZATIONS',
    term: 'Lemmatizations',
    childrenKeyTypes: [],
  },
}

export default INGREDIENT_KEYWORD_SUBTYPES
